// src/pages/SkillsPage.jsx
import React from "react";
import Skills from "../components/Skills/Skills";
import SkillsTimeline from "../components/Skills/SkillsTimeline";
import SEO from "../components/common/SEO";

const SkillsPage = () => {
  const skillsStructuredData = {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    "name": "Mihir Shah - Technical Skills & Expertise",
    "description": "Comprehensive overview of cybersecurity skills, cloud security expertise, and technical certifications.",
    "url": "https://mihirshah.tech/skills",
    "mainEntity": {
      "@type": "Person",
      "name": "Mihir Shah",
      "knowsAbout": [
        "Cloud Security",
        "Application Security", 
        "DevSecOps",
        "Kubernetes Security",
        "Container Security",
        "OWASP Standards",
        "Vulnerability Management",
        "Security Architecture",
        "Penetration Testing",
        "Security Compliance"
      ],
      "hasCredential": [
        {
          "@type": "EducationalOccupationalCredential",
          "name": "OSCP - Offensive Security Certified Professional"
        },
        {
          "@type": "EducationalOccupationalCredential", 
          "name": "CKA - Certified Kubernetes Administrator"
        },
        {
          "@type": "EducationalOccupationalCredential",
          "name": "CKS - Certified Kubernetes Security Specialist"
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Technical Skills & Expertise - Mihir Shah"
        description="Explore comprehensive cybersecurity skills including cloud security, application security, DevSecOps, Kubernetes, and OWASP standards. Professional certifications and technical expertise."
        keywords="cybersecurity skills, cloud security expertise, DevSecOps skills, Kubernetes security, OSCP, CKA, CKS, application security, penetration testing, security architecture"
        url="https://mihirshah.tech/skills"
        type="website"
        section="Skills"
        tags={["Skills", "Cybersecurity", "Cloud Security", "Certifications"]}
        structuredData={skillsStructuredData}
      />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 py-20">
        <div className="container mx-auto px-4">
          {/* Page Header */}
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-vxdf-primary to-vxdf-accent bg-clip-text text-transparent">
              Technical Skills & Expertise
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Comprehensive cybersecurity expertise spanning cloud security, application security, and modern DevSecOps practices
            </p>
          </div>

          <Skills />
          <SkillsTimeline />
        </div>
      </div>
    </>
  );
};

export default SkillsPage;
